module.exports = __webpack_public_path__ + "img/shape-3.02217f9c.svg";